module.exports = {
    globalScope: 'g_livequotes',
    langs: ['en', 'es', 'ru', 'pt_BR'],
    wsgate: 'wss://ws-gate.fxclub.org/ws',
    quotes_api: 'https://quote.fxclub.org',
    gaterest_api: 'https://gaterest.fxclub.org/real/restapi/quotes'
};



// WEBPACK FOOTER //
// ./config/index.js